import type { FunctionComponent, VoidFunctionComponent } from 'react';

import { ignoreOrResolveWordPast } from '../../../utils';
import Button from '../../generic/Button/Button';
import FallbackImage from '../../generic/FallbackImage';
import type { FallbackImageProps } from '../../generic/FallbackImage';

//  Issue-specific fallback image, which includes the white background (which FallbackImage isn't responsible for).
const IssuesFallbackImage: FunctionComponent<FallbackImageProps> = ({
  children,
  ...props
}) => (
  <div className="issues-table-body">
    <FallbackImage
      // eslint-disable-next-line react/jsx-props-no-spreading -- It's fine.
      {...props}
    >
      {children}
    </FallbackImage>
  </div>
);

export const Error: VoidFunctionComponent = () => (
  <IssuesFallbackImage
    src="error-plug"
    alt="Network error"
  >
    <div>Oops! There was an error.</div>
    <div>Please try again in a bit.</div>
  </IssuesFallbackImage>
);

export const NoResults: VoidFunctionComponent<{ onResetButtonClick: () => void }> = ({ onResetButtonClick }) => (
  <IssuesFallbackImage
    src="no-results"
    alt="No issues found"
    hasPadding
  >
    <div>We couldn&apos;t find any results.</div>
    <Button
      type="text"
      size="large"
      onClick={onResetButtonClick}
    >
      Reset filters
    </Button>
  </IssuesFallbackImage>
);

export const NoActiveIssues: VoidFunctionComponent = () => (
  <IssuesFallbackImage
    src="tada"
    alt="No open issues"
    hasPadding
  >
    No issues here! Give yourself a pat on the back.
  </IssuesFallbackImage>
);

export const NoIgnoredIssues: VoidFunctionComponent = () => {
  const resolvedOrIgnored = ignoreOrResolveWordPast().toLowerCase();
  return (
    <IssuesFallbackImage
      src="circle-checkmark"
      alt={`No ${resolvedOrIgnored} issues`}
      hasPadding
    >
      No issues are {resolvedOrIgnored}.
    </IssuesFallbackImage>
  );
};
